<template>
  <div class="consulte_container">
    <div
      v-if="formData && formData.length > 0"
      class="mb20"
      v-for="item in formData"
      :key="item.id"
    >
      <div class="consult_img">
        <img
          :src="item.informationTitleImage"
          alt=""
          @click="newsDetail(item.informationId)"
        />
      </div>
      <div class="honor">
        <div class="honor_title">{{ item.informationTitle }}</div>
        <div class="honor_bot">
          <span>{{ item.createdon }}</span>
          <span>{{ pageView() }}浏览</span>
        </div>
      </div>
    </div>
    <van-divider v-else>暂无数据</van-divider>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formData: []
      }
    },
    created() {
      this.getData()
    },
    methods: {
      pageView() {
        return parseInt(Math.random() * 700 + 300);
      },
      async getData() {
        const param = {
          pageNum: 1,
          pageSize: 100
        }
        const data = await this.$api.getInformation(param)
        if (data.success) {
          this.formData = data.datas.content
        }
      },
      newsDetail(informationId) {
        console.log(informationId)
        const userAgent = navigator.userAgent.toLocaleLowerCase();
        const isAndroid = ! !~userAgent.indexOf("android");
        const isIos = ! !~navigator.userAgent.toLocaleLowerCase().indexOf("ios");
        let result
        if (isAndroid) {
          result = window.android.startWebActivity(`http://h5.chezhiguan.com/detail?informationId=${informationId}`);
        }
        if (isIos) {
          window.webkit.messageHandlers.methodName.postMessage(`http://h5.chezhiguan.com/detail?informationId=${informationId}`)
        }
      }
    }

  }
</script>
<style>
  body {
    background-image: linear-gradient(109deg, #ebf3f9 41%, #f3f7fb 99%);
  }
</style>
<style lang="scss" scoped>
  .consulte_container {
    .mb20 {
      margin-bottom: 20px;
    }
    padding: 20px 15px 0 15px;
    box-sizing: border-box;
    /*background-image: linear-gradient(109deg, #EBF3F9 41%, #F3F7FB 99%);*/
    .title {
      font-family: "PingFangSC-Medium";
      font-size: 19px;
      color: #000000;
      text-align: center;
      margin-bottom: 30px;
    }
    .consult_img {
      width: 100%;
      height: 167px;
      background-image: linear-gradient(
        180deg,
        #242329 0%,
        #33333b 54%,
        #2d2e33 100%
      );
      border-radius: 12px 12px 0 0;
      text-align: center;
      overflow: hidden;
      // background: #ffffff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .honor {
      width: 100%;
      /*height: 182px;*/
      box-sizing: border-box;
      padding: 0 15px;
      margin-bottom: 12px;
      background: #ffffff;
      border-radius: 6px;
      .honor_title {
        width: 100%;
        height: 51px;
        line-height: 51px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
        font-family: "PingFangSC-Medium";
        font-size: 15px;
        color: #2c2e34;
        margin-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .honor_info {
        height: 78px;
        display: flex;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
        // line-height: 78px;
        justify-content: space-between;
        span {
          display: inline-block;
        }
        .txt {
          height: 100%;
          width: 248px;
          // margin-right: 38px;
          box-sizing: border-box;
          padding-top: 15px;
          font-family: "PingFangSC-Medium";
          font-size: 15px;
          color: #2c2e34;
          line-height: 20px;
        }
        .hon_img {
          width: 65px;
          height: 61px;
          // margin-left: 38px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .honor_bot {
        width: 100%;
        height: 37px;
        display: flex;
        justify-content: space-between;
        font-family: "PingFangSC-Regular";
        font-size: 12px;
        line-height: 37px;
        color: #777e88;
      }
    }
    .con_new {
      width: 100%;
      // height: 255px;
      background: #ffffff;
      margin-bottom: 12px;
      border-radius: 12px 12px 0 0;
      // .consult_img{
      //     background-image: linear-gradient(180deg, #242329 0%, #33333B 54%, #2D2E33 100%);
      // }
      .con_honor {
        width: 100%;
        height: 51px;
        box-sizing: border-box;
        padding: 0 15px;
        // margin-bottom: 10px;
        background: #ffffff;
        border-radius: 6px;
        .con_tit {
          width: 100%;
          height: 51px;
          line-height: 51px;
          border-bottom: 1px solid rgba(151, 151, 151, 0.3);
          font-family: "PingFangSC-Medium";
          font-size: 15px;
          color: #2c2e34;
        }
      }
      .honor_bot {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: space-between;
        font-family: "PingFangSC-Regular";
        font-size: 12px;
        line-height: 36px;
        padding: 0 15px;
        color: #777e88;
      }
    }
    .con_list {
      width: 100%;
      background: #ffffff;
      box-sizing: border-box;
      padding: 0 15px;
      ul {
        li {
          height: 94px;
          display: flex;
          border-bottom: 1px solid rgba(151, 151, 151, 0.3);
          // line-height: 78px;
          justify-content: space-between;
          // margin-bottom: 10px;
          box-sizing: border-box;
          padding-top: 15px;
          span {
            display: inline-block;
          }
          .txt {
            height: 100%;
            width: 248px;
            // margin-right: 38px;
            box-sizing: border-box;
            padding-top: 15px;
            font-family: "PingFangSC-Medium";
            font-size: 15px;
            color: #2c2e34;
          }
          .hon_img {
            width: 65px;
            height: 61px;
            // margin-left: 38px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .list_bot {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: space-between;
        font-family: "PingFangSC-Regular";
        font-size: 12px;
        line-height: 36px;
        padding: 0 15px;
        color: #777e88;
      }
    }
  }
</style>
